

// import React from 'react'
// import LabelDesign from "./LabelDesign";
// import ProductLanding from "./ProductLanding";
// import Bottle from './Bottle';
// import Footer from './Footer';
// import Header from './Header';
// import About from './About';
// import Testimonials from './Testimonials';

// const App = () => {
//   return (
//     <>
//       <Header />
//       <LabelDesign />
//       <Bottle />
//       <About />
//       <Testimonials />
//       <Footer />
//     </>

//   )
// };

// export default App


// import React, { useState, useEffect } from 'react';
// import Header from './Header';
// import LabelDesign from "./LabelDesign";
// import Bottle from './Bottle';
// import About from './About';
// import Testimonials from './Testimonials';
// import OrderSection from './OrderSection';
// import Footer from './Footer';

// const App = () => {
//   const [isMobile, setIsMobile] = useState(false);
//   const [scrollY, setScrollY] = useState(0);

//   // Global responsive monitor checking and scroll data synchronization
//   useEffect(() => {
//     const handleResize = () => setIsMobile(window.innerWidth < 1024); // Calibrated for high-end corporate layouts
//     const handleScroll = () => setScrollY(window.scrollY);

//     handleResize();
//     window.addEventListener('resize', handleResize);
//     window.addEventListener('scroll', handleScroll);

//     return () => {
//       window.removeEventListener('resize', handleResize);
//       window.removeEventListener('scroll', handleScroll);
//     };
//   }, []);

//   const styles = {
//     appWrapper: {
//       minHeight: "100vh",
//       width: "100%",
//       backgroundColor: "#2c3437",
//       color: "#ffffff",
//       overflowX: "hidden",
//       boxSizing: "border-box",
//       margin: 0,
//       padding: 0
//     },
//     mainContainer: {
//       width: "100%",
//       display: "flex",
//       flexDirection: "column",
//     }
//   };

//   return (
//     <div style={styles.appWrapper}>
//       {/* Sticky Global Infrastructure Navigation Bar */}
//       <Header isMobile={isMobile} isScrolled={scrollY > 50} />

//       <main style={styles.mainContainer}>

//         {/* 1. Immersive Production Landing Screen */}
//         <LabelDesign isMobile={isMobile} />

//         {/* 2. Interactive Auto-Rotating Product Display Screen */}
//         <Bottle scrollProgress={scrollY} isMobile={isMobile} />

//         {/* 3. National Industrial Compliance & Quality Specifications Screen */}
//         <About isMobile={isMobile} />

//         {/* 4. Verified Enterprise Procurement & Client Verification Track */}
//         <Testimonials isMobile={isMobile} />

//         {/* 5. Production Matrix Price Calculator & Wholesale Inquiry Module */}
//         {/* <OrderSection isMobile={isMobile} /> */}

//       </main>

//       {/* 6. Corporate Footnote, Operations Summary & Legal Certifications Board */}
//       <Footer isMobile={isMobile} />
//     </div>
//   );
// };

// export default App;


import React, { useState, useEffect } from 'react';
import Header from './Header';
import LabelDesign from "./LabelDesign";
import Bottle from './Bottle';
import About from './About';
import Testimonials from './Testimonials';
import OrderSection from './OrderSection';
import Footer from './Footer';

// Move static styles outside component to avoid object re-creation per render
const styles = {
  appWrapper: {
    minHeight: "100vh",
    width: "100%",
    backgroundColor: "#2c3437",
    color: "#ffffff",
    overflowX: "hidden",
    boxSizing: "border-box",
    margin: 0,
    padding: 0
  },
  mainContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  }
};

const App = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    // 1. Mobile Check using MatchMedia (efficient, only updates when threshold flips)
    const mediaQuery = window.matchMedia('(max-width: 1023px)');
    const handleMediaChange = (e) => setIsMobile(e.matches);
    
    // Set initial state
    setIsMobile(mediaQuery.matches);
    mediaQuery.addEventListener('change', handleMediaChange);

    // 2. Throttled Scroll Listener using requestAnimationFrame
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setScrollY(window.scrollY);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      mediaQuery.removeEventListener('change', handleMediaChange);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div style={styles.appWrapper}>
      {/* Sticky Global Infrastructure Navigation Bar */}
      <Header isMobile={isMobile} isScrolled={scrollY > 50} />

      <main style={styles.mainContainer}>

        {/* 1. Immersive Production Landing Screen */}
        <LabelDesign isMobile={isMobile} />

        {/* 2. Interactive Auto-Rotating Product Display Screen */}
        <Bottle scrollProgress={scrollY} isMobile={isMobile} />

        {/* 3. National Industrial Compliance & Quality Specifications Screen */}
        <About isMobile={isMobile} />

        {/* 4. Verified Enterprise Procurement & Client Verification Track */}
        <Testimonials isMobile={isMobile} />

        {/* 5. Production Matrix Price Calculator & Wholesale Inquiry Module */}
        {/* <OrderSection isMobile={isMobile} /> */}

      </main>

      {/* 6. Corporate Footnote, Operations Summary & Legal Certifications Board */}
      <Footer isMobile={isMobile} />
    </div>
  );
};

export default App;